import {addClass, removeClass} from "../_vars";
import {disableScroll} from "./disableScroll.js";

export const clientsPlay = () => {
   const modal = document.querySelector("#video-review");
   let videoPopup;

   addEventListener("click", (e) => {
      const closeBtn = e.target.closest(".video-review__close");
      if (closeBtn) {
         const video = closeBtn.parentElement.querySelector("video,iframe");
         video.remove();
      }

      const targetEvent = e.target.closest(".play-clients, .clients-item, .say-video");
      if (!targetEvent) return;
      const target = targetEvent.matches(".play-clients") ? targetEvent : targetEvent.querySelector(".play-clients");

      const isInsidePopup = target.closest("[data-modal-block]");
      const videoParent = modal.querySelector(".video-review__video");
      if (!isInsidePopup) {
         const video = target.parentElement.querySelector("video,iframe");
         videoParent.innerHTML = video.outerHTML + '<button class="clients-item__play play-clients btn-reset" aria-label="Запустить видео"><svg><use xlink:href="img/sprite.svg#play-icon"></use></svg></button>';
         videoPopup = videoParent.querySelector("video,iframe");
         videoPopup.setAttribute("controls", "");
         if (typeof videoPopup.play === "function") videoPopup.play();

         videoPopup.addEventListener("pause", () => {
            removeClass(playPopup, "--hidden");
            removeClass(videoParent, "--play");
         });
         videoPopup.addEventListener("play", () => {
            addClass(playPopup, "--hidden");
            addClass(videoParent, "--play");
         });
         const playPopup = modal.querySelector(".play-clients");


         addClass(playPopup, "--hidden");
         addClass(videoParent, "--play");

         addClass(modal, "--show");
         window.activePopup = modal;
         disableScroll();
      } else {
         videoPopup = videoParent.querySelector("video,iframe");
         const playPopup = modal.querySelector(".play-clients");
         videoPopup.play();
         removeClass(playPopup, "--hidden");
         removeClass(videoParent, "--play");
      }
   });
};
